import React, { useState, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import AppHeader from './AppHeader';

function Layout({ config }) {
  const [isConfigSaved, setIsConfigSaved] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Verificar si la configuración está guardada
    const savedConfig = localStorage.getItem('uniformApp_config');
    if (savedConfig) {
      const parsedConfig = JSON.parse(savedConfig);
      // Considerar configuración guardada si hay nombre de cliente y prendas configuradas
      if (parsedConfig.clientName && parsedConfig.garmentTypes && parsedConfig.garmentTypes.length > 0) {
        setIsConfigSaved(true);
      } else {
        setIsConfigSaved(false);
      }
    } else {
      setIsConfigSaved(false);
    }
  }, [config]);

  // Función para actualizar el estado de configuración guardada
  const handleConfigSaved = () => {
    setIsConfigSaved(true);
  };

  // Verificar si es la primera vez que se accede a la aplicación
  const isFirstAccess = !localStorage.getItem('uniformApp_config') || 
    !config.clientName || 
    !config.garmentTypes || 
    config.garmentTypes.length === 0;

  // Si es el primer acceso y no estamos en la página de configuración, redirigir
  useEffect(() => {
    if (isFirstAccess && location.pathname !== '/config') {
      navigate('/config');
    }
  }, [isFirstAccess, location.pathname, navigate]);

  return (
    <div className="max-w-4xl mx-auto p-2 sm:p-4 space-y-2 bg-gray-100 min-h-screen">
      <AppHeader config={config} isConfigSaved={isConfigSaved} />
      <main className="pt-0">
        <Outlet context={{ isFirstAccess, isConfigSaved, onConfigSaved: handleConfigSaved }} />
      </main>
    </div>
  );
}

export default Layout;